import { createFileRoute, redirect } from '@tanstack/react-router';

// Redirect from old insights url to new reporting url
export const Route = createFileRoute('/_secured/insights')({
  beforeLoad: ({ location }) => {
    // Get the path after /insights (e.g., /insights/dashboards/123 -> /dashboards/123)
    const pathAfterInsights = location.pathname.replace(/^\/insights/, '');

    throw redirect({
      to: `/reporting${pathAfterInsights}` as any,
    });
  },
});
